import { cn } from 'cn'
import type * as React from 'react'

export interface SpinnerProps extends React.SVGProps<SVGSVGElement> {
  className?: string
}

export function Spinner({ className, ...props }: SpinnerProps) {
  return (
    <svg
      className={cn('animate-spin', className)}
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      {...props}
    >
      <path
        d='M16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5ZM2.00019 8.5C2.00019 11.8136 4.6864 14.4998 8 14.4998C11.3136 14.4998 13.9998 11.8136 13.9998 8.5C13.9998 5.1864 11.3136 2.50019 8 2.50019C4.6864 2.50019 2.00019 5.1864 2.00019 8.5Z'
        fill='#E2E8F0'
      />
      <path
        d='M1.0464 12.4557C-0.0027115 10.6115 -0.276248 8.42605 0.285969 6.38016C0.848185 4.33427 2.2001 2.59552 4.04431 1.5464C5.88852 0.497289 8.07395 0.223752 10.1198 0.785969C12.1657 1.34819 13.9045 2.7001 14.9536 4.54431L13.2152 5.53323C12.4284 4.15008 11.1243 3.13614 9.58988 2.71448C8.05546 2.29281 6.41639 2.49797 5.03323 3.2848C3.65008 4.07164 2.63614 5.3757 2.21448 6.91012C1.79281 8.44454 1.99797 10.0836 2.7848 11.4668L1.0464 12.4557Z'
        fill='#3182CE'
      />
    </svg>
  )
}
